import React, { useEffect } from "react";
import { Spacer } from "styles/common/spacer";
import Image from "next/legacy/image";

import {
  CMBOnDiffNumberButton,
  CMBPhoneNumber,
  CMBPhoneNumberInfo,
  CMBAckHeading,
  CMBAckWrapper,
  OkayButton,
  OfficeHoursInfo,
  OfficeHoursInfoWrapper
} from "./kelas-live-cmb-ack-modal.styles";
import { KelasLiveCMBStages } from "../kelas-live-cmb.types";
import { KelasLiveCMBModal } from "../kelas-live-cmb-modal/kelas-live-cmb-modal";
import trackEvent from "services/mixpanel/mixpanel";
import { kelasLiveEvents } from "services/mixpanel/kelas-live-events";
import { IPrimaryUser } from "services/api/api.types";

const KelasLiveCMBAckModal: React.FC<{
  onClose: () => void;
  handleOnClick: (stage: KelasLiveCMBStages) => void;
  phoneNumber: string;
  onGoingClassExists: boolean;
  primary_user: IPrimaryUser;
  isShowingCallDifferentNumber?: boolean;
}> = ({
  onClose,
  handleOnClick,
  phoneNumber,
  onGoingClassExists,
  primary_user,
  isShowingCallDifferentNumber = true
}) => {
  const primaryPhoneNumber = primary_user.phone_number;

  const isNumberChanged = primaryPhoneNumber !== phoneNumber;

  useEffect(() => {
    trackEvent({
      eventName: kelasLiveEvents.kakakSiagaCallSuccessViewed,
      payload: {
        cause: "USER_CLICK",
        eventSource: "website",
        isClassOngoing: onGoingClassExists,
        successScreenType: isNumberChanged
          ? "POST_NUMBER_CHANGE"
          : "POST_BUTTON_CLICK"
      }
    });
  }, [isNumberChanged, onGoingClassExists]);

  const handleOkayButtonClick = () => {
    trackEvent({
      eventName: kelasLiveEvents.okayKakSuccessScreenClicked
    });
    handleOnClick(KelasLiveCMBStages.INITIAL_STAGE);
  };

  const handleCallDiffNumberButtonClick = () => {
    trackEvent({
      eventName: kelasLiveEvents.callMeDiffNumberClicked
    });
    handleOnClick(KelasLiveCMBStages.SHOW_FORM_STAGE);
  };

  return (
    <KelasLiveCMBModal isOpen={true} onClose={onClose}>
      <CMBAckWrapper>
        <Image
          src="/assets/kelas-live/kakak-siaga-with-phone.svg"
          alt="Kakak siaga with phone"
          width={256}
          height={256}
          priority
        />
        <Spacer token={[0, 0, 16]} />
        <CMBAckHeading>
          Kakak Siaga akan telepon kamu di <br /> jam kerja
        </CMBAckHeading>
        <Spacer token={[0, 0, 16]} />
        <OfficeHoursInfoWrapper>
          <OfficeHoursInfo>Senin - Jumat, 11.00 - 20.00 WIB</OfficeHoursInfo>
          <OfficeHoursInfo>Sabtu, 08.00 - 15.00 WIB</OfficeHoursInfo>
        </OfficeHoursInfoWrapper>
        <Spacer token={[0, 0, 16]} />
        <CMBPhoneNumberInfo>
          Nomormu
          <CMBPhoneNumber> +62{phoneNumber}</CMBPhoneNumber>
        </CMBPhoneNumberInfo>
        <Spacer token={[0, 0, 4]} />
        {isShowingCallDifferentNumber && (
          <CMBOnDiffNumberButton
            onClick={handleCallDiffNumberButtonClick}
            variant="link"
          >
            Telepon ke nomor yang beda
          </CMBOnDiffNumberButton>
        )}
        <Spacer token={[0, 0, 20]} />
        <OkayButton
          variant="primary"
          isFullWidth={true}
          onClick={handleOkayButtonClick}
        >
          Oke, Kak
        </OkayButton>
      </CMBAckWrapper>
    </KelasLiveCMBModal>
  );
};

export { KelasLiveCMBAckModal };
